import React from "react";
import Map from "../../components/map";
import Listview from "../../components/listview";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { getGeoJSON, getAllProjects } from "../../actions/data";
import {
    selectGeoJSON,
    selectActivePage,
    selectMapType,
} from "../../reducers/";
import styles from "./root.module.scss";
import { connect } from "react-redux";
import ErrorBoundary from "./error-boundary";
import Loading from "../../components/loading";
import FundPopup from "../../components/project-popup";
import PropTypes from "prop-types";
import geojsonConfig from "../../modules/geojsonConfig";
import queryString from "query-string";

class Root extends React.Component {
    componentDidMount() {
        this.props.getAllProjects();
        this.fetchGeoJson();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mapType !== this.props.mapType) {
            this.fetchGeoJson();
        }
    }

    fetchGeoJson() {
        const currentConfig = geojsonConfig[this.props.mapType];

        this.props.getGeoJSON(
            currentConfig.geojsonUrl,
            currentConfig.topologyObjectsName
        );
    }

    renderContent() {
        const { activePage, mapType } = this.props;
        const query = queryString.parse(window.location.search);
        if (activePage === "map") {
            return (
                <div className={styles.container}>
                    <Map
                        idSelector={geojsonConfig[mapType].idSelector}
                        idCol={geojsonConfig[mapType].idCol}
                    />
                    {query.sheetName && query.sheetName.includes("regional-recovery-map") && (
                        <Footer/>
                    )}
                </div>
            );
        } else {
            return <Listview />;
        }
    }
    render() {
        const { geojson, mapType } = this.props;
        if (geojson === null) return <Loading />;
        return (
            <ErrorBoundary>
                <div className={styles.container}>
                    <Header
                        nameSelector={geojsonConfig[mapType].nameSelector}
                    />
                    <FundPopup />
                    {this.renderContent()}
                </div>
            </ErrorBoundary>
        );
    }
}
const mapStateToProps = state => ({
    geojson: selectGeoJSON(state),
    activePage: selectActivePage(state),
    mapType: selectMapType(state),
});

Root.defaultProps = {
    mapType: "lga",
};

Root.propTypes = {
    getGeoJSON: PropTypes.func.isRequired,
    getAllProjects: PropTypes.func.isRequired,
    mapType: PropTypes.string.isRequired,
    activePage: PropTypes.string,
    geojson: PropTypes.object,
};
const mapDispatchToProps = { getGeoJSON, getAllProjects };
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Root);



// WEBPACK FOOTER //
// ./src/pages/root/root.js